// src/api/users.js
import api from '@/services/axios';

/**
 * Holt die Benutzerliste (Admin only).
 * Optional: page, limit, q (Suche), sortBy, sortDir
 */
export function getUsers(params = {}) {
  return api.get('/users', { params });
}

/** Neuen Benutzer anlegen (Admin only) */
export function createUser(payload) {
  // payload: { password, first_name, last_name, email, avatar_url?, role }
  return api.post('/users', payload);
}

/** Benutzer updaten (Admin only) */
export function updateUser(id, payload) {
  return api.put(`/users/${id}`, payload);
}

/** Benutzer löschen (Admin only) */
export function deleteUser(id) {
  return api.delete(`/users/${id}`);
}
